'use strict';
const angular = require('angular');
const {isArray, isObject, isString, lowercase} = angular;
const includes = require('lodash/includes');

export const filterDomainImport = [
  filterDomain];

function filterDomain() {
  return function (list, query) {
    if (!query || typeof query !== 'string') return list;

    //console.log('filtering with query ' + query);
    query = lowercase(query);
    //console.log('filtering with query ' + query);

    var matching, item, itemKey, itemProperty, result = {};

    for (itemKey in list) {
      if (list.hasOwnProperty(itemKey)) {
        matching = false;
        item = list[itemKey];

        if (item && isObject(item)) {

          for (itemProperty in item) {
            if (item.hasOwnProperty(itemProperty)) {

              if (!item[itemProperty]) {
              } else if (isString(item[itemProperty]) && includes(item[itemProperty].toLowerCase(), query)) {
                matching = true;
                break;
              } else if (isObject(item[itemProperty])) {
              } else if (isArray(item[itemProperty])) {
              }
            }
          }

          if (matching) {
            result[itemKey] = list[itemKey];
          }
        }
      }
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/filterDomain.js